import { useT } from '@/shared/lib/i18n';
import { CogIcon } from '@/shared/ui';
import { StartCta } from './StartCta';

export type MobileLobbyFooterProps = {
  isHost: boolean;
  canStart: boolean;
  canEditSettings: boolean;
  playerCount: number;
  summaryChip: string;
  onOpenSettings: () => void;
  onStart: () => void;
};

/** Mobile lobby footer — cog settings trigger + StartCta. */
export const MobileLobbyFooter = ({
  isHost,
  canStart,
  canEditSettings,
  playerCount,
  summaryChip,
  onOpenSettings,
  onStart,
}: MobileLobbyFooterProps) => {
  const t = useT();
  return (
    <div className="flex flex-col gap-2">
      {canEditSettings && (
        <button
          type="button"
          onClick={onOpenSettings}
          aria-label={t('setup.host_settings.title')}
          className="relative flex w-full items-center justify-center gap-2.5 rounded-[var(--radius-btn)] border-2 border-cream bg-transparent px-4 py-3 font-display font-extrabold text-[15px] text-cream transition active:translate-y-[1px]"
        >
          <CogIcon />
          <span>{t('setup.host_settings.title')}</span>
          <span className="ml-auto rounded-[6px] border border-cream/30 bg-cream/10 px-2 py-0.5 font-display font-extrabold text-[11px] text-cream tabular-nums tracking-[0.04em]">
            {summaryChip}
          </span>
        </button>
      )}
      <StartCta isHost={isHost} canStart={canStart} needMore={playerCount < 3} onStart={onStart} />
    </div>
  );
};
